module.exports = __webpack_public_path__ + "static/media/academy.36128e9a.png";